<form [formGroup]="addToCartForm" (ngSubmit)="addProductToCart($event)">
  <div
    class="quantity"
    *ngIf="showQuantity && isAvailable && (authService.isUserLoggedIn() | async)"
  >
    <label class="eb-add-to-cart__quantity-label">{{ 'addToCart.quantity' | cxTranslate }}</label>
    <eb-item-counter
      [max]="maxQuantity"
      [control]="addToCartForm.get('quantity')"
      [attr.data-cy]="'cart-quantity'"
      [pushMatomoEvents]="false"
    ></eb-item-counter>
    <eb-product-sales-text
      [cssClass]="'eb-add-to-cart'"
      [salesText]="product?.productSalesView?.salesText"
    ></eb-product-sales-text>
  </div>

  <ng-container *ngIf="isAvailable; else noLongerAvailable">
    <div
      [ngbTooltip]="
        (authService.isUserLoggedIn() | async) ? '' : ('addToCart.loginFirst' | cxTranslate)
      "
    >
      <button
        class="eb-add-to-cart__button"
        [class.eb-add-to-cart__small]="iconOnly"
        [attr.data-cy]="
          hasSuccessor ? 'add_successor_variant_' + productCode : 'add_variant_' + productCode
        "
        type="submit"
        [ngbTooltip]="iconOnly ? (addToCartTooltipI18NKey | cxTranslate) : ''"
        [disabled]="
          quantity <= 0 || quantity > maxQuantity || !(authService.isUserLoggedIn() | async)
        "
      >
        <span *ngIf="!iconOnly">
          {{ addToCartTooltipI18NKey | cxTranslate }}
        </span>
        <span class="fas fa-cart-plus" [class.add-to-cart__icon]="!iconOnly"></span>
        <span *ngIf="hasSuccessor && iconOnly" class="fas fa-info"></span>
        <span
          *ngIf="showCountOfProductInCart && count > 0"
          class="eb-add-to-cart__show-count-of-product-in-cart"
          >{{ count }}</span
        >
      </button>
    </div>
  </ng-container>
  <ng-template #noLongerAvailable>
    <button *ngIf="hasStock" class="eb-add-to-cart__button" type="submit" [disabled]="!isAvailable">
      {{ 'addToCart.noLongerAvailable' | cxTranslate }}
    </button>
  </ng-template>
</form>
